import { __ } from '~@/Composables/translation'

export default [
    { value: 'placeholder', example: __('tools.emails.placeholders.help_on_template_logic.placeholder'), link: '' },
    { value: 'if', example: '', link: 'https://laravel.com/docs/10.x/blade#if-statements' },
    { value: 'switch', example: '', link: 'https://laravel.com/docs/10.x/blade#switch-statements' },
    { value: 'for/foreach', example: '', link: 'https://laravel.com/docs/10.x/blade#loops' },
    { value: 'links', example: '<a href="https://www.google.co.uk/">Google</a>', link: '' },
    { value: 'bold', example: '<strong>text</strong>', link: '' },
    { value: 'italic', example: '<em>text</em>', link: '' },
    {
        value: 'heading',
        example: '' +
            '<h1>John</h1>\n' +
            '<h2>John</h2>\n' +
            '<h3>John</h3>',
        link: ''
    },
    {
        value: 'list',
        example: '' +
            '<ul>\n' +
            '  <li>John</li>\n' +
            '  <li>Paul</li>\n' +
            '  <li>George</li>\n' +
            '</ul>\n',
        link: ''
    },
    {
        value: 'list-numbered',
        example: '' +
            '<ol>\n' +
            '  <li>John</li>\n' +
            '  <li>Paul</li>\n' +
            '  <li>George</li>\n' +
            '</ol>\n',
        link: ''
    },
    { value: 'linebreaks', example: '<br />', link: '' }
]
